import {
  suggestOrgIdFromEmail,
  suggestOrgIdFromName,
  suggestOrgNameFromEmail
} from './checkout-org-id';

export interface SignupPrefill {
  email?: string;
  orgName?: string;
  orgId?: string;
}

export const SIGNUP_PREFILL_STORAGE_KEY = 'spothr.signupPrefill';
export const SIGNUP_PLATFORM_TOKEN_STORAGE_KEY = 'spothr.signupPlatformToken';

const trimValue = (value?: string) => value?.trim() || '';

export const createSignupPrefill = (account: {
  email?: string;
  name?: string;
}): SignupPrefill => {
  const email = trimValue(account.email);
  const orgName = suggestOrgNameFromEmail(email) || trimValue(account.name);
  const orgId = suggestOrgIdFromName(orgName) || suggestOrgIdFromEmail(email);

  return {
    ...(email ? { email } : {}),
    ...(orgName ? { orgName } : {}),
    ...(orgId ? { orgId } : {})
  };
};

export const saveSignupPrefill = (prefill: SignupPrefill) => {
  const nextPrefill = {
    ...(trimValue(prefill.email) ? { email: trimValue(prefill.email) } : {}),
    ...(trimValue(prefill.orgName)
      ? { orgName: trimValue(prefill.orgName) }
      : {}),
    ...(trimValue(prefill.orgId) ? { orgId: trimValue(prefill.orgId) } : {})
  };

  if (Object.keys(nextPrefill).length === 0) {
    sessionStorage.removeItem(SIGNUP_PREFILL_STORAGE_KEY);
    return;
  }

  sessionStorage.setItem(
    SIGNUP_PREFILL_STORAGE_KEY,
    JSON.stringify(nextPrefill)
  );
};

export const saveSignupPlatformToken = (token?: string) => {
  const trimmedToken = trimValue(token);

  if (!trimmedToken) {
    sessionStorage.removeItem(SIGNUP_PLATFORM_TOKEN_STORAGE_KEY);
    return;
  }

  sessionStorage.setItem(SIGNUP_PLATFORM_TOKEN_STORAGE_KEY, trimmedToken);
};

export const getSignupPlatformToken = (): string | null =>
  sessionStorage.getItem(SIGNUP_PLATFORM_TOKEN_STORAGE_KEY);

export const clearSignupPlatformToken = () => {
  sessionStorage.removeItem(SIGNUP_PLATFORM_TOKEN_STORAGE_KEY);
};

export const consumeSignupPrefill = (): SignupPrefill => {
  const rawValue = sessionStorage.getItem(SIGNUP_PREFILL_STORAGE_KEY);
  sessionStorage.removeItem(SIGNUP_PREFILL_STORAGE_KEY);

  if (!rawValue) {
    return {};
  }

  try {
    return JSON.parse(rawValue) as SignupPrefill;
  } catch {
    return {};
  }
};
